import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1ed93edc&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/daum/program/jenkins/workspace/cafe-web/cafe-web-production/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ed93edc')) {
      api.createRecord('1ed93edc', component.options)
    } else {
      api.reload('1ed93edc', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=1ed93edc&", function () {
      api.rerender('1ed93edc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/bbs-list/bottom/App.vue"
export default component.exports